import {ComponentService} from "./service/component";
import {Application} from "./application/application";
import {FormSignUpComponent} from "./components/form-sign-up";

require("@babel/polyfill");
require('picturefill/dist/picturefill.js');

(($) => $(() => {

    let components = new ComponentService();
    components.addComponent('.js-signup-form', FormSignUpComponent, 'FormSignUpComponent');
    new Application(components);

}))(jQuery);
